<template>
  <div id="image-tab-list" class="image-tab-list flex-column d-flex ">
    <div :key="index" v-for="(item,index) in links">
      <div class="d-flex pointer" @click="newTab(item.href)">
        <el-image class="rounded m-1" :style="{padding:item.thumb?'':(+7+'px')}"
                  style="max-width: 40px;max-height: 40px;min-width: 40px;min-height: 40px;border: 1px solid #ccc"
                  :src="getSrc(item)" />
        <div class="d-flex flex-column justify-content-center flex-1 px-1">
          <strong class="text-1-line  pb-0 ">{{ item.description }}</strong>
          <div style="color:dodgerblue">{{ JSON.parse(item.params).src }}</div>
        </div>
      </div>
      <div class="divider-custom" />

    </div>
    <scroll-loader :loader-method="getLinks" :loader-disable="noMore">
      <div v-loading="false"></div>
    </scroll-loader>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";

export default {
  name: "LinkTab",
  props: ["conversation"],
  data() {
    return {
      noMore: false,
      links: [],
      ts: "",
      pageSize: 40
    };
  },
  methods: {
    getSrc(item) {
      return item.thumb != null && item.thumb != "" ? item.thumb : "/assets/images/icon_link.svg";
    },

    getLinks() {
      let request = {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        timestamp: this.links.length > 0 ? this.links[this.links.length - 1].ts : "",
        msgTypes: [COMMON.CHAT_LINK],
        pageSize: this.pageSize
      };
      this.$http.post("/api/message/filter", request).then(resp => {
          let data = resp.data.map(s => JSON.parse(s.content));
          this.links = this.links.concat(data);
          if (resp.data.length < this.pageSize) this.noMore = true;
        }
      );
    }
  }

};

</script>

<style scoped>
</style>